module.exports = __webpack_public_path__ + "static/img/ar.073297d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/ar.png
// module id = QD0B
// module chunks = 18